"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BG = void 0;
exports.BG = {
    numericCode: '100',
    alpha2Code: 'BG',
    alpha3Code: 'BGR',
    englishName: {
        short: 'Bulgaria',
        full: 'the Republic of Bulgaria',
    },
    names: {
        full: {
            en: 'the Republic of Bulgaria',
            fr: 'la République de Bulgarie',
            bg: 'Bulgaria',
        },
        short: {
            en: 'Bulgaria',
            fr: 'Bulgarie (la)',
            bg: 'Bulgaria',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'bg',
            languageAlpha3Code: 'bul',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
    ],
    subdivisions: {
        'BG-01': {
            numericCode: '100',
            code: 'BG-01',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Blagoevgrad',
            },
        },
        'BG-02': {
            numericCode: '100',
            code: 'BG-02',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Burgas',
            },
        },
        'BG-03': {
            numericCode: '100',
            code: 'BG-03',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Varna',
            },
        },
        'BG-04': {
            numericCode: '100',
            code: 'BG-04',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Veliko Tarnovo',
            },
        },
        'BG-05': {
            numericCode: '100',
            code: 'BG-05',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Vidin',
            },
        },
        'BG-06': {
            numericCode: '100',
            code: 'BG-06',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Vratsa',
            },
        },
        'BG-07': {
            numericCode: '100',
            code: 'BG-07',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Gabrovo',
            },
        },
        'BG-08': {
            numericCode: '100',
            code: 'BG-08',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Dobrich',
            },
        },
        'BG-09': {
            numericCode: '100',
            code: 'BG-09',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Kardzhali',
            },
        },
        'BG-10': {
            numericCode: '100',
            code: 'BG-10',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Kyustendil',
            },
        },
        'BG-11': {
            numericCode: '100',
            code: 'BG-11',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Lovech',
            },
        },
        'BG-12': {
            numericCode: '100',
            code: 'BG-12',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Montana',
            },
        },
        'BG-13': {
            numericCode: '100',
            code: 'BG-13',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Pazardzhik',
            },
        },
        'BG-14': {
            numericCode: '100',
            code: 'BG-14',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Pernik',
            },
        },
        'BG-15': {
            numericCode: '100',
            code: 'BG-15',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Pleven',
            },
        },
        'BG-16': {
            numericCode: '100',
            code: 'BG-16',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Plovdiv',
            },
        },
        'BG-17': {
            numericCode: '100',
            code: 'BG-17',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Razgrad',
            },
        },
        'BG-18': {
            numericCode: '100',
            code: 'BG-18',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Ruse',
            },
        },
        'BG-19': {
            numericCode: '100',
            code: 'BG-19',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Silistra',
            },
        },
        'BG-20': {
            numericCode: '100',
            code: 'BG-20',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Sliven',
            },
        },
        'BG-21': {
            numericCode: '100',
            code: 'BG-21',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Smolyan',
            },
        },
        'BG-22': {
            numericCode: '100',
            code: 'BG-22',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Sofia (stolitsa)',
            },
        },
        'BG-23': {
            numericCode: '100',
            code: 'BG-23',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Sofia',
            },
        },
        'BG-24': {
            numericCode: '100',
            code: 'BG-24',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Stara Zagora',
            },
        },
        'BG-25': {
            numericCode: '100',
            code: 'BG-25',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Targovishte',
            },
        },
        'BG-26': {
            numericCode: '100',
            code: 'BG-26',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Haskovo',
            },
        },
        'BG-27': {
            numericCode: '100',
            code: 'BG-27',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Shumen',
            },
        },
        'BG-28': {
            numericCode: '100',
            code: 'BG-28',
            category: {
                id: '361',
                names: {
                    bg: {
                        singular: 'oblast',
                        plural: '',
                    },
                    en: {
                        singular: 'district',
                        plural: 'districts',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bg: 'Yambol',
            },
        },
    },
    cities: [
        {
            name: 'Yambol',
            subdivision: 'Yambol',
        },
        {
            name: 'Vratsa',
            subdivision: 'Vratsa',
        },
        {
            name: 'Vidin',
            subdivision: 'Vidin',
        },
        {
            name: 'Velingrad',
            subdivision: 'Pazardzhik',
        },
        {
            name: 'Veliko Tŭrnovo',
            subdivision: 'Veliko Tŭrnovo',
        },
        {
            name: 'Varna',
            subdivision: 'Varna',
        },
        {
            name: 'Targovishte',
            subdivision: 'Tŭrgovishte',
        },
        {
            name: 'Troyan',
            subdivision: 'Lovech',
        },
        {
            name: 'Dobrich',
            subdivision: 'Dobrich',
        },
        {
            name: 'Svishtov',
            subdivision: 'Veliko Tŭrnovo',
        },
        {
            name: 'Svilengrad',
            subdivision: 'Khaskovo',
        },
        {
            name: 'Stara Zagora',
            subdivision: 'Stara Zagora',
        },
        {
            name: 'Dupnitsa',
            subdivision: 'Kyustendil',
        },
        {
            name: 'Sofia',
            subdivision: 'Sofia-Capital',
        },
        {
            name: 'Smolyan',
            subdivision: 'Smolyan',
        },
        {
            name: 'Sliven',
            subdivision: 'Sliven',
        },
        {
            name: 'Silistra',
            subdivision: 'Silistra',
        },
        {
            name: 'Shumen',
            subdivision: 'Shumen',
        },
        {
            name: 'Sevlievo',
            subdivision: 'Gabrovo',
        },
        {
            name: 'Sandanski',
            subdivision: 'Blagoevgrad',
        },
        {
            name: 'Samokov',
            subdivision: 'Sofiya',
        },
        {
            name: 'Ruse',
            subdivision: 'Ruse',
        },
        {
            name: 'Razgrad',
            subdivision: 'Razgrad',
        },
        {
            name: 'Rakovski',
            subdivision: 'Plovdiv',
        },
        {
            name: 'Popovo',
            subdivision: 'Tŭrgovishte',
        },
        {
            name: 'Plovdiv',
            subdivision: 'Plovdiv',
        },
        {
            name: 'Pleven',
            subdivision: 'Pleven',
        },
        {
            name: 'Petrich',
            subdivision: 'Blagoevgrad',
        },
        {
            name: 'Peshtera',
            subdivision: 'Pazardzhik',
        },
        {
            name: 'Pernik',
            subdivision: 'Pernik',
        },
        {
            name: 'Pazardzhik',
            subdivision: 'Pazardzhik',
        },
        {
            name: 'Panagyurishte',
            subdivision: 'Pazardzhik',
        },
        {
            name: 'Nova Zagora',
            subdivision: 'Sliven',
        },
        {
            name: 'Montana',
            subdivision: 'Montana',
        },
        {
            name: 'Lovech',
            subdivision: 'Lovech',
        },
        {
            name: 'Lom',
            subdivision: 'Montana',
        },
        {
            name: 'Kyustendil',
            subdivision: 'Kyustendil',
        },
        {
            name: 'Kardzhali',
            subdivision: 'Kŭrdzhali',
        },
        {
            name: 'Haskovo',
            subdivision: 'Khaskovo',
        },
        {
            name: 'Kharmanli',
            subdivision: 'Khaskovo',
        },
        {
            name: 'Kazanlŭk',
            subdivision: 'Stara Zagora',
        },
        {
            name: 'Karnobat',
            subdivision: 'Burgas',
        },
        {
            name: 'Karlovo',
            subdivision: 'Plovdiv',
        },
        {
            name: 'Gotse Delchev',
            subdivision: 'Blagoevgrad',
        },
        {
            name: 'Gorna Oryakhovitsa',
            subdivision: 'Veliko Tŭrnovo',
        },
        {
            name: 'Gabrovo',
            subdivision: 'Gabrovo',
        },
        {
            name: 'Dimitrovgrad',
            subdivision: 'Khaskovo',
        },
        {
            name: 'Chirpan',
            subdivision: 'Stara Zagora',
        },
        {
            name: 'Cherven Bryag',
            subdivision: 'Pleven',
        },
        {
            name: 'Burgas',
            subdivision: 'Burgas',
        },
        {
            name: 'Botevgrad',
            subdivision: 'Sofiya',
        },
        {
            name: 'Blagoevgrad',
            subdivision: 'Blagoevgrad',
        },
        {
            name: 'Berkovitsa',
            subdivision: 'Montana',
        },
        {
            name: 'Aytos',
            subdivision: 'Burgas',
        },
        {
            name: 'Asenovgrad',
            subdivision: 'Plovdiv',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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